import React, { useState, useEffect, useRef, useContext } from 'react';
import './css/SingleItemCarousel.css';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import axiosInstance from '../../utils/axiosInstance';
import { AuthContext } from '../../context/AuthContext';

const SingleItemCarousel = ({ autoSlideInterval = 5000 }) => {
   const { loadingHandle } = useContext(AuthContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);
  const [items, setItems] = useState([])

const fetchCarousel = async ()=>{
  try {
            const response = await axiosInstance.get(`/carousel`)
            console.log(response,"response")
          
            setItems(response.data);
        } catch (err) {
            // setError('Failed to fetch slides. Please make sure the server is running.');
            console.error(err);
        } 
}
  useEffect(()=>{
    loadingHandle(true)
    fetchCarousel()
    loadingHandle(false)
  },[])
   const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () => setCurrentIndex((prevIndex) => (prevIndex === items.length - 1 ? 0 : prevIndex + 1)),
      autoSlideInterval
    );
    return () => {
      resetTimeout();
    };
  }, [currentIndex, items, autoSlideInterval]);
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? items.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  const goToNext = () => {
    const isLastSlide = currentIndex === items.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };
  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };



  return (
    // The main container is already relative from the CSS file
    <div className="single-item-carousel">
      

      <div className="carousel-viewport">
        <div
          className="carousel-slides-container"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {items.map((item, index) => (
            <div className="carousel-slide" key={index}>
              <img src={item.image_url} alt={item.altText} className="carousel-image" />
            </div>
          ))}
        </div>
      </div>

      <button className="carousel-button prev" onClick={goToPrevious}>
        <HiChevronLeft size={30} />
      </button>
      <button className="carousel-button next" onClick={goToNext}>
        <HiChevronRight size={30} />
      </button>

      <div className="carousel-dots">
        {items.map((_, slideIndex) => (
          <div
            key={slideIndex}
            className={`dot ${currentIndex === slideIndex ? 'active' : ''}`}
            onClick={() => goToSlide(slideIndex)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default SingleItemCarousel;